import { Pipe, PipeTransform } from '@angular/core';
import { RegistryItem, RegistryItemEssential } from 'src/app/api/models';

@Pipe({
  name: 'registryPrint',
  standalone: false,
})
export class RegistryPrintPipe implements PipeTransform {
  transform(value: RegistryItem, field: 'comune' | 'provincia' | 'regione'): string {
    if (value) {
      switch (field) {
        case 'comune':
          return value.delivery_italy_city?.name || value.city;
        case 'provincia':
          return value.delivery_italy_province?.name || value.province;
        case 'regione':
          return value.delivery_italy_region?.name || 'N.D.';
      }
    }
    return 'N.D.';
  }
}
